module.exports = __webpack_public_path__ + "static/sci-ltd-logo-9b259c48f7f1b4710a263001fbc3f759.png";